import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';

// components
import { FormattedMessage } from 'react-intl';
import Gallery from 'dibs-vg/dist/react/gallery';
import { SharedContactDealerWrapper } from '../../contactDealer/SharedContactDealerWrapper';

// styles
import styles from './PdpRespHeroCarouselRequestMoreImages.scss';

export const PdpRespHeroCarouselRequestMoreImagesComponent = props => {
    const { item, user = {}, disableRequestMoreImagesModal } = props;

    const contactSellerLink = (
        <a className={styles.link}>
            <FormattedMessage
                id="PdpRespHeroCarouselRequestMoreImages.contactSeller"
                defaultMessage="Contact Seller"
            />
        </a>
    );

    return (
        <div className={styles.container}>
            <Gallery className={styles.icon} />
            <div className={styles.header}>
                <FormattedMessage
                    id="PdpRespHeroCarouselRequestMoreImages.requestMoreImagesHeader"
                    defaultMessage="Want more images?"
                />
            </div>
            <div className={styles.subheader}>
                <FormattedMessage
                    id="PdpRespHeroCarouselRequestMoreImages.requestMoreImagesSubheader"
                    defaultMessage="Request additional images from the seller"
                />
            </div>
            {disableRequestMoreImagesModal ? (
                contactSellerLink
            ) : (
                <CurrencyProvider
                    render={({ currency }) => (
                        <SharedContactDealerWrapper
                            item={item}
                            user={user}
                            launchOrigin="pdp image carousel"
                            modalType="REQUEST_IMAGES"
                            currency={currency}
                        >
                            {contactSellerLink}
                        </SharedContactDealerWrapper>
                    )}
                />
            )}
        </div>
    );
};

PdpRespHeroCarouselRequestMoreImagesComponent.defaultProps = {
    disableRequestMoreImagesModal: false,
};

PdpRespHeroCarouselRequestMoreImagesComponent.propTypes = {
    disableRequestMoreImagesModal: PropTypes.bool.isRequired,
    item: PropTypes.object,
    user: PropTypes.object,
    relay: PropTypes.object.isRequired,
};

export const PdpRespHeroCarouselRequestMoreImages = createFragmentContainer(
    PdpRespHeroCarouselRequestMoreImagesComponent,
    {
        item: graphql`
            fragment PdpRespHeroCarouselRequestMoreImages_item on Item {
                ...SharedContactDealerWrapper_item
                serviceId
            }
        `,
        user: graphql`
            fragment PdpRespHeroCarouselRequestMoreImages_user on User {
                ...SharedContactDealerWrapper_user
                serviceId
            }
        `,
    }
);
